/**
 * Which screen a submitted form belongs to (the server's `FormChannel`, NB-355): Purchase Requests, the forms of
 * PR Templates. Default Template Forms, which held every other kind, was removed on 2026-10-16.
 */
export type FormsChannelKey = 'purchase-requests';

/** Whether a form filled in from a template of `templateKind` is a Purchase Request. */
export function isPurchaseRequestKind(templateKind: string): boolean {
  return templateKind === 'PURCHASE_REQUEST';
}
